import { actionTypes, RENAME_GATEWAY_REQUEST, RENAME_GATEWAY } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { clearStore as clearRebootGatewayStore } from './Header/RebootGateway/actions';
import { clearStore as clearActivateDeactivateGatewayStore } from './Header/ActivateDeactivateGateway/actions';
import { clearStore as clearDeleteGatewayStore } from './Header/DeleteGateway/actions';
import { clearStore as clearRefreshNetaGatewayStore } from './Header/RefreshGateway/actions';
import { clearStore as clearUpdateFirmwareStore } from './Header/UpdateFirmware/actions';
import { clearStore as clearDeleteAssetStore } from './ConnectedAssets/ConnectedAssetsDrives/DeleteAsset/actions';
import { CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE } from './ConnectedAssets/ConnectedAssetsDrives/SwitchToAnotherGateway/constants';

const headerClearActions = [
    clearRebootGatewayStore,
    clearActivateDeactivateGatewayStore,
    clearDeleteGatewayStore,
    clearRefreshNetaGatewayStore,
    clearUpdateFirmwareStore,
    clearDeleteAssetStore
];

export const getGatewayInfoAction = getApiActionCreator(actionTypes.GET_GATEWAY_INFO_SETTINGS);
export const getRenameGatewayAction = getApiActionCreator(RENAME_GATEWAY);
export const getUserCapabilitiesAction = getApiActionCreator(actionTypes.GET_USER_CAPABILITY_SETTINGS);

export const getUserCapabilities = (dcuId) => {
    return {
        type: actionTypes.GET_USER_CAPABILITY,
        payload: {
            dcuId
        }
    };
};
export const getGatewayInfo = (gatewayID) => {
    return {
        type: actionTypes.GET_GATEWAY_INFO,
        payload: {
            gatewayID
        }
    };
};

export const getGatewayConnectedAssetsAction = getApiActionCreator(actionTypes.GET_GATEWAY_CONNECTED_ASSETS_SETTINGS);

export const getGatewayConnectedAssets = (gatewayID) => {
    return {
        type: actionTypes.GET_GATEWAY_CONNECTED_ASSETS,
        payload: {
            gatewayID
        }
    };
};

export const getDownloadInstallationReportAction = getApiActionCreator(actionTypes.DOWNLOAD_INSTALLATION_REPORT_SETTINGS);
export const getDownloadDiagnosticReportAction = getApiActionCreator(actionTypes.DOWNLOAD_DIAGNOSTIC_REPORT_SETTINGS);

export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};

export const clearGatewayCapabilities = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_GATEWAY_CAPABILITIES });
    };
};

export const clearAllHeaderStores = () => {
    return (dispatch) => {
        headerClearActions.forEach((clearAction) => dispatch(clearAction()));
        dispatch({ type: actionTypes.CLEAR_INSTALLATION_REPORT });
        dispatch({ type: actionTypes.CLEAR_DOWNLOAD_DIAGNOSTIC_REPORT });
        dispatch({ type: CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE });
    };
};


export const renameGateway = (gatewayID, newName, organizationID, filters = null, siteIds = [], gatewayFilter = null) => ({
    type: RENAME_GATEWAY_REQUEST,
    payload: {
        gatewayID,
        newName,
        organizationID,
        filters,
        siteIds,
        gatewayFilter
    }
});

export const clearInstallationReport = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_INSTALLATION_REPORT });
    };
};

export const getConnectionHistoryGatewayAction = getApiActionCreator(actionTypes.GET_CONNECTION_HISTORY_GATEWAY_SETTINGS);
export const getConnectionHistoryAssetAction = getApiActionCreator(actionTypes.GET_CONNECTION_HISTORY_ASSET_SETTINGS);

export const getConnectionHistoryGateway = (gatewayID) => {
    return {
        type: actionTypes.GET_CONNECTION_HISTORY_GATEWAY,
        payload: {
            gatewayID
        }
    };
};

export const clearConnectionHistory = () => {
    return {
        type: actionTypes.CLEAR_CONNECTION_HISTORY
    };
};

export const getConnectedHistoryAction = getApiActionCreator(actionTypes.GET_CONNECTED_HISTORY_SETTINGS);

export const getConnectedHistory = ({ gatewayId, pageSize, keyword, sortBy, startTime, endTime, nextCursor, prevCursor }) => ({
    type: actionTypes.GET_CONNECTED_HISTORY,
    payload: { gatewayId, pageSize, keyword, sortBy, startTime, endTime, nextCursor, prevCursor },
});

export const clearConnectedHistory = () => ({
    type: actionTypes.CLEAR_CONNECTED_HISTORY,
});
